import { Component } from "@angular/core";
import { defer } from "lodash-es";
import { AuthApi } from "../../../../domain/api/auth.api";
import { CompanyApi } from "../../../../domain/api/company.api";
import { UserApi } from "../../../../domain/api/user.api";
import { BasePageComponent } from "../base-page.component";
import { ProfileFormComponent } from "./profile-form.component";

@Component({
	selector: "app-profile",
	imports: [ProfileFormComponent],
	template: `
        <div class="flex w-full p-2">
            <app-profile-form [user]="user()" [company]="company()"/>

        </div>

    `,
	styles: [],
})
export class ProfilePageComponent extends BasePageComponent {
	user = this.userApi.byId(this.authApi.me()()!.id);
	company = this.companyApi.byId(this.authApi.me()()!.companyId);
	constructor(
		private readonly userApi: UserApi,
		private readonly authApi: AuthApi,
		private readonly companyApi: CompanyApi,
	) {
		super();
	}

	override onInit() {
		super.onInit();
		defer(async () => {
			await Promise.all([
				this.userApi.fetch(this.authApi.me()()!.id),
				this.companyApi.fetch(this.authApi.me()()!.companyId),
			]);
		});
	}
}
